<script setup lang="ts">
  import { Text, IconLocked, IconUnlocked, Tag } from "@ui-kit";
  import { ItemZoneCarousel } from "../ItemZoneCarousel";

  const { article, zones, isBlocked } = defineProps<{
    article: string;
    zones: Array<{
      id: string;
      path: string;
      location: string;
    }>;
    isBlocked?: boolean;
  }>();
</script>

<template>
  <div class="product-zone__info">
    <div class="product-zone__info-header">
      <Text data-testid="product-article">{{ article }}</Text>
      <Tag v-if="isBlocked" variant="error" data-testid="product-zone-item-blocked">
        <IconLocked />
      </Tag>
      <Tag v-else variant="success" data-testid="product-zone-item-unblocked">
        <IconUnlocked />
      </Tag>
    </div>
    <ItemZoneCarousel :zones="zones" />
  </div>
</template>

<style scoped>
  .product-zone__info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    overflow: hidden;

    & :deep(.item-zone-carousel__row) {
      padding: 9px 0px;
    }
  }

  .product-zone__info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .product-zone__info-header :deep(.icon) {
    width: 16px;
    height: 16px;
    stroke: var(--sf-tag-text-success);
  }
</style>
